module.exports = __webpack_public_path__ + "img/PRamShip64_ua.10ced84b.webp";